<template>
	<div id="centerWidth" :style="{ height: windowHeight + 'px' }" style="overflow: auto;" @scroll="scrollEvent($event)">
		<div class="centerWidth">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>根据专业选科目</span>
			</div>
			<section class="gaokao-content">
				<div class="my-title">根据专业选科目</div>
				<article class="major-share">
					<div class="major-share-con">
						<div class="share-li">
							<p>搜索专业:</p>
							<input v-model="majorName" placeholder="请输入专业名称" />
						</div>
						<div class="major-btn01"><button class="gaokao-btn" v-on:click="GetList(1)">搜索</button></div>
					</div>
				</article>
				<!-- 2.13 -->
				<section class="system">
					<article class="table">
						<hgroup class="flex">
							<p>院校名称</p>
							<p>专业名称</p>
							<p style="width: 170px;">包含专业</p>
							<p>首选科目</p>
							<p style="width: 320px;">选科科目要求</p>
							<p>备注</p>
						</hgroup>
						<ul>
							<li class="flex zhong" v-for="(item, index) in CollegeList" :key="index">
								<div class="lia">
									<p class="shou pttlan" @click="getCollegesList(item.CollegesName)">{{ item.CollegesName }}</p>
								</div>
								<div class="lia">
									<p class="shou pttlan" @click="getNewProfessionalTypeList(item.MajorName)">{{ item.MajorName }}</p>
								</div>
								<div class="lia" style="width: 170px;">
									<p>{{ item.ContainMajor }}</p>
								</div>
								<div class="lia">
									<p>{{ item.PreferredSubject }}</p>
								</div>
								<div class="lia" style="width: 320px;">
									<p>{{ item.RequirementsSubjects }}</p>
								</div>
								<div class="lia">
									<p>{{ item.Remarks }}</p>
								</div>
							</li>
						</ul>
					</article>
				</section>
			</section>
		</div>
		<!-- 院校 -->
		<aside class="popup flex zhong center" v-if="isYxPop">
			<div class="aside_pop" style="cursor:pointer;">
				<div class="aside_height" v-if="yxList.length > 0">
					<ul>
						<li v-for="(item, index) in yxList" :key="index" @click="yuanTo(item.CollegesName)">{{ item.CollegesName }}</li>
					</ul>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
				<div class="aside_btn flex zhong center"><button class="zhun_btn" @click="isYxPop = false">关闭</button></div>
			</div>
		</aside>
		<!-- 专业 -->
		<aside class="popup flex zhong center" v-if="isZyPop">
			<div class="aside_pop" style="cursor:pointer;">
				<div class="aside_height" v-if="zyList.length > 0">
					<ul>
						<li v-for="(item, index) in zyList" :key="index" @click="zhuanTo(item.Id)">{{ item.Name }}</li>
					</ul>
				</div>
				<div class="ptend_gao" v-else>
					<div class=" ptend_div">
						<img src="../../../image/empty.png" />
						<p>暂无数据</p>
					</div>
				</div>
				<div class="aside_btn flex zhong center"><button class="zhun_btn" @click="isZyPop = false">关闭</button></div>
			</div>
		</aside>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isZyPop: false,
			zyList: [],
			isYxPop: false,
			yxList: [],
			// 2.23
			options: [],
			subjectId: '',
			// 列表
			list: [],
			firstSubject: '',
			schoolName: '',
			subjectName: '',
			majorName: '',
			totleNum: 0,
			page: 1,
			pageSize: 10,
			isPage: false,
			CollegeList: [],
			windowHeight: document.documentElement.clientHeight
		};
	},
	watch: {
		windowHeight(val) {
			const that = this;
			console.log('实时屏幕高度：', val, that.windowHeight);
		}
	},
	mounted() {
		const that = this;
		window.onresize = () => {
			return (() => {
				window.fullHeight = document.documentElement.clientHeight;
				that.windowHeight = window.fullHeight;
			})();
		};
		this.GetList(1);
		if (this.$route.query.key) {
			this.$api.reduceUserCount({
				key: this.$route.query.key
			});
		} else {
			this.$router.back(-1);
		}
	},
	methods: {
		scrollEvent(e) {
			var that = this;
			var scrollBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
			console.log('滚动', scrollBottom);
			if (scrollBottom < 10) {
				if (that.isPage) {
					console.log('翻页');
					that.isPage = false;
					var pg = that.page + 1;
					that.GetList(pg);
				}
			}
		},
		zhuanTo(Id) {
			// this.$router.push('/majorinfo');
			window.open(`${window.location.origin}${window.location.pathname}#/majorinfo?Id=${Id}`);
		},
		getNewProfessionalTypeList(name) {
			var that = this;
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			// that.zyList = [];
			that.$api.HtppRequest(
				'SystemData/NewProfessionalTypeList?page=1&pageSize=99&name=' + name,
				'GET',
				{},
				function(res) {
					console.log('获取列表', res);
					if (res.code === 0) {
						that.isZyPop = true;
						that.zyList = res.data.list;
					}
					loading.close();
				},
				function(err) {
					loading.close();
					console.log(err);
				}
			);
		},
		getCollegesList(name) {
			var that = this;
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			// that.yxList = [];
			that.$api.HtppRequest(
				'SystemData/GetCollegesDataList',
				'POST',
				{
					page: 1,
					size: 99,
					colleges: name
				},
				function(res) {
					console.log('获取列表', res);
					if (res.flag) {
						that.isYxPop = true;
						that.yxList = res.list;
					}
					loading.close();
				},
				function(err) {
					loading.close();
					console.log(err);
				}
			);
		},
		yuanTo(CollegesName) {
			// this.$router.push('/schoolinfo');
			// 院校名称
			window.open(`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${CollegesName}`);
		},
		// 以上 2.23
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 查看更多
		moreBtn(id) {
			var that = this;
			var list = that.CollegeList;
			for (var i = 0; i < list.length; i++) {
				if (list[i].Id === id) {
					list[i].isMore = !list[i].isMore;
				}
			}
			that.CollegeList = list;
		},
		// 上一步
		goTestb() {
			this.$router.push('/gktestb');
		},
		// 下一步
		goTestd() {
			this.$router.push('/gktestd');
		},
		// 获取列表
		GetList: function(page) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/SelectMajorToSubject',
				'POST',
				{
					page: page,
					size: 10,
					collegesName: that.schoolName,
					majorName: that.majorName,
					preferredSubject: that.firstSubject,
					selectedSubjects: that.subjectName
				},
				function(res) {
					console.log('获取列表', res);
					if (res.flag) {
						var list = res.list;
						if (list.length > 0) {
							// var newList = [];
							that.isPage = true;
							// for (var i = 0; i < list.length; i++) {
							// 	newList.push({
							// 		Id: list[i].Id,
							// 		CityCode: list[i].CityCode,
							// 		CollegesCode: list[i].CollegesCode,
							// 		CollegesName: list[i].CollegesName,
							// 		MajorCode: list[i].MajorCode,
							// 		MajorName: list[i].MajorName,
							// 		ContainMajor: list[i].ContainMajor,
							// 		PreferredSubject: list[i].PreferredSubject,
							// 		RequirementsSubjects: list[i].RequirementsSubjects,
							// 		Remarks: list[i].Remarks,
							// 		CreateTime: list[i].CreateTime,
							// 		isMore: false
							// 	});
							// }
							if (page === 1) {
								that.CollegeList = list;
							} else {
								that.CollegeList = that.CollegeList.concat(list);
							}
							that.page = page;
							that.totleNum = res.totle;
							console.log('page', page);
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 获取其他页
		GetPageList: function(val) {
			var that = this;
			that.GetList(val);
			console.log(`当前页: ${val}`);
		}
	}
};
</script>

<style scoped>
.aside_height li {
	border-bottom: solid 1px #eeeeee;
	padding: 14px 0;
	text-indent: 1em;
	font-size: 14px;
	color: #666666;
}

.aside_height {
	height: 320px;
	overflow-y: auto;
	border-radius: 6px;
	border: solid 1px #eeeeee;
}

.zypt {
	display: inline-block;

	border-bottom: solid 1px #94918f;
	cursor: pointer;
}
.zhun_btn.on {
	background-color: #005371;
}

.zhun_btn {
	width: 120px;
	height: 40px;
	background-color: #666;
	border-radius: 4px;
	font-size: 14px;
	color: #fff;
	line-height: 40px;
	margin-right: 20px;
	display: block;
	cursor: pointer;
}

.zhun_btn:last-child {
	margin-right: 0;
}

.aside_btn .zhun_btn {
	background-color: #333;
	border: solid 1px #333;
}

.aside_btn .zhun_btn:first-child {
	background-color: #fff;
	color: #333;
	border: solid 1px #333;
}

.aside_btn {
	margin-top: 40px;
}

.aside_box {
	width: 70%;
	margin: 0 10px;
}

.aside_div {
	width: 90%;
	margin: 0 auto;
}

.aside_pop {
	width: 520px;
	border-radius: 10px;
	background-color: #fff;
	padding: 50px 20px 20px 20px;
}

/* aside_pop */

.lia p {
	padding: 0 10px;
	box-sizing: border-box;
	font-size: 14px;
	text-align: center;
	color: #666666;
	position: relative;
}

.lia::after {
	content: '';
	width: 1px;
	height: 300%;
	background-color: #e6e6e6;
	position: absolute;
	right: 0;
	top: -30px;
	z-index: 0;
}

.lia {
	padding: 20px 0;
	width: calc(100% / 6);
	position: relative;
}

.lia:last-child::after {
	width: 0px;
}

.img_box img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.img_box {
	border-radius: 6px;
	width: 96px;
	height: 68px;
	margin: 0 auto;
	overflow: hidden;
}

/* img_box */

.pageDiv {
	overflow: hidden;
	margin-top: 20px;
}

.table li p {
	font-size: 14px;
	text-align: center;
}

.table li {
	border-bottom: solid 1px #e6e6e6;
}

.table li:last-child {
	border-bottom: none;
}

.table li p:last-child {
	border-right: none;
}

.table ul {
	overflow: hidden;
}

.table hgroup p:last-child {
	border-right: none;
}

.table hgroup p {
	font-size: 14px;
	background-color: #eaeaea;
	border-right: solid 1px #e6e6e6;
	width: calc(100% / 6);
	line-height: 60px;
	text-align: center;
}

.table {
	overflow: hidden;
	border: solid 1px #e6e6e6;
	box-sizing: border-box;
}

.system {
	overflow: hidden;
	padding: 20px;
}

/* safety */

/* 2.23 */
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}

.gaokao-nav span {
	font-size: 15px;
	color: #333;
}

.gaokao-nav span:last-child {
	color: #333;
}

/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}

/* major-share */
.major-share {
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #eaeaea;
	display: flex;
	margin: 20px auto 30px auto;
	padding: 30px 0;
}

.major-share-con {
	width: 75%;
	height: auto;
	overflow: ;
	display: flex;
	flex-wrap: wrap;
}

.share-li {
	width: 50%;
	display: flex;
	align-items: center;
	/* justify-content: center; */
	margin: 10px 0;
}

.share-li p {
	font-size: 14px;
	color: #333;
	width: 100px;
	text-align: right;
	margin-right: 20px;
}

.share-li input {
	width: 270px;
	height: 40px;
	line-height: 40px;
	padding: 0 10px;
	display: block;
	border-radius: 5px;
	background-color: #fff;
	color: #333;
	font-size: 14px;
}

.share-li input::-webkit-input-placeholder {
	color: #999;
}

.share-li input:-moz-placeholder {
	color: #999;
}

.share-li input:-ms-input-placeholder {
	color: #999;
}

.sjWidth {
	width: 270px;
}

.major-btn01 {
	width: 25%;
	display: flex;
	align-items: flex-end;
}

.major-btn01 button {
	margin: 10px auto;
	width: 120px;
}

/* major-list */
.major-list {
	width: 100%;
	height: auto;
	margin-top: 15px;
}

.major-list ul {
	width: 100%;
	height: auto;
}

.major-list ul li {
	border: 1px solid #eee;
	width: 100%;
	height: auto;
	padding: 20px 30px;
	margin-bottom: 20px;
	position: relative;
}

.major-li01 {
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
}

.major-li-btn {
	width: 20%;
}

.major-li-btn p {
	width: 170px;
	height: 33px;
	line-height: 33px;
	text-align: center;
	background-color: #333;
	font-size: 16px;
	color: #fff;
	border-radius: 50px;
}

.major-li01-right {
	width: 80%;
	display: flex;
	flex-wrap: wrap;
}

.major-li01-right p {
	width: 25%;
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}

.major-li01-right p span {
	font-size: 15px;
	color: #999;
}

.major-li01-right p span:last-child {
	color: #333;
}

.major-li01-right p:nth-child(3) {
	width: 50%;
}

.major-li01-right .zy-width {
	width: 75%;
}

.major-li02 {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.major-li02 p {
	font-size: 14px;
}

.major-txt01 {
	width: 75px;
	color: #999;
}

.major-txt02 {
	width: calc(100% - 120px);
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.major-more {
	width: 45px;
	color: #333;
	text-align: right;
	cursor: pointer;
}

.major-txt04 {
	color: #333;
}

.major-more-con {
	position: absolute;
	width: 98%;
	height: auto;
	background: rgba(0, 0, 0, 0.7);
	padding: 20px;
	font-size: 15px;
	color: #fff;
	left: 1%;
	bottom: 0;
	border-radius: 5px;
	margin-bottom: -14px;
	z-index: 1;
}

.major-more-con::after {
	position: absolute;
	content: '';
	right: 0;
	top: 0;
	width: 0;
	height: 0;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-bottom: 14px solid rgba(0, 0, 0, 0.7);
	margin-top: -14px;
	margin-right: 24px;
}

.major-page {
	margin-bottom: 30px;
}
</style>
